import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosGateway } from "../../../api/axios";
import ENDPOINTS from "../../../api/endpoints";

const normalizeTpl = (data) => {
  const raw = data?.layout || data?.template || data?.data || data || null;
  if (!raw || typeof raw !== "object") return null;

  return {
    description: raw.description ?? null,
    couleurTexte: raw.couleurTexte ?? null,
    couleurLogo: raw.couleurLogo ?? null,
    logoUrl: raw.logoUrl ?? null,
    active: raw.active ?? true,

    fullName: raw.fullName ?? null,
    fullNameAr: raw.fullNameAr ?? null,
    specialty: raw.specialty ?? null,
    specialtyAr: raw.specialtyAr ?? null,
    phone: raw.phone ?? null,
    email: raw.email ?? null,
    address: raw.address ?? null,
    addressAr: raw.addressAr ?? null,
  };
};

export const fetchPrescriptionLayout = createAsyncThunk(
  "prescriptionLayout/fetch",
  async (doctorId, { rejectWithValue }) => {
    try {
      if (!doctorId) {
        console.warn("[fetchPrescriptionLayout] doctorId manquant, skip");
        return null;
      }

      const url = ENDPOINTS.PRESCRIPTION.TEMPLATE.GET(doctorId);

      const res = await axiosGateway.get(url);
      return normalizeTpl(res.data);
    } catch (err) {
      const status = err?.response?.status;

      if (status === 403) return null;
      if (status === 404) return null;

      const msg =
        err?.response?.data?.message ||
        err?.message ||
        "Erreur lors du chargement du layout";

      return rejectWithValue(msg);
    }
  }
);

export const savePrescriptionLayout = createAsyncThunk(
  "prescriptionLayout/save",
  async ({ doctorId, layout }, { rejectWithValue }) => {
    try {
      if (!doctorId) throw new Error("doctorId manquant pour savePrescriptionLayout");

      const url = ENDPOINTS.PRESCRIPTION.TEMPLATE.CREATE(doctorId);
      const body = {
        description: layout.description ?? null,
        couleurTexte: layout.couleurTexte ?? null,
        couleurLogo: layout.couleurLogo ?? null,
        logoUrl: layout.logoUrl ?? null,
        active: layout.active ?? true,

        fullName: layout.fullName ?? null,
        fullNameAr: layout.fullNameAr ?? null,
        specialty: layout.specialty ?? null,
        specialtyAr: layout.specialtyAr ?? null,
        phone: layout.phone ?? null,
        email: layout.email ?? null,
        address: layout.address ?? null,
        addressAr: layout.addressAr ?? null,
      };

      const res = await axiosGateway.post(url, body);
      return { ...normalizeTpl(res.data), doctorId };
    } catch (err) {
      const msg =
        err?.response?.data?.message ||
        err?.message ||
        "Erreur lors de la sauvegarde du layout";
      return rejectWithValue(msg);
    }
  }
);
